/**
 * ViewVouchers Constants
 * Contains all constants used in the ViewVouchers screen
 */

// Initial state for edit operations
export const INITIAL_EDIT_STATUS = {
    isEditing: false,
    editingField: null,
    editSenderName: '',
    editReceiverName: '',
    editMessage: '',
    editReceiverMobile: '',
    editValidationError: '',
};

// Initial state for activation modal
export const INITIAL_ACTIVATION_STATUS = {
    activationSuccess: false,
    validated: false,
    activationError: '',
    activationLoading: false,
};

// Initial state for merchant group modal
export const INITIAL_MERCHANT_GROUP_STATUS = {
    showMerchantGroupModal: false,
    selectedVoucherId: null,
    currentMerchantGroup: null,
};

// Status keys that are allowed for dropdown operations
export const ALLOWED_STATUS_KEYS = ['ACTIVE', 'INACTIVE', 'PENDING_ACTIVATION', 'EXPIRED'];

// Default page size
export const DEFAULT_PAGE_SIZE = 100;

// Table headings configuration
export const TABLE_HEADINGS = {
    voucher: {
        column: [
            'Voucher ID',
            'Sender',
            'Created Date',
            'Receiver',
            'Receiver Number',
            'Amount',
            'Status',
            'Invoice Number',
        ],
    },
    transaction: {
        column: ['Date', 'Description', 'Amount'],
    },
    transferred: {
        column: ['Date', 'From', 'To', 'Admin'],
    },
};

// Tab items configuration (status tabs and search dropdown)
export const TAB_ITEMS = {
    status: [
        { key: 'ALL', label: 'All' },
        { key: 'ACTIVE', label: 'Active' },
        { key: 'PENDING_ACTIVATION', label: 'Activation Pending ' },
        { key: 'INACTIVE', label: 'Inactive' },
        { key: 'EXPIRED', label: 'Expired' },
        { key: 'DELETED', label: 'Deleted' }
    ],
    searchDropDown: [
        { key: 'id', label: 'Voucher ID', placeholder: 'Voucher ID' },
        {
            key: 'mobile_no',
            label: 'Receiver Number',
            placeholder: 'Receiver Number',
        },
        {
            key: 'sender_name',
            label: 'Sender Name',
            placeholder: 'Sender Name',
        },
        {
            key: 'receiver_name',
            label: 'Receiver Name',
            placeholder: 'Receiver Name',
        },
        {
            key: 'created_date',
            label: 'Created Date',
            placeholder: 'YYYY-MM-DD',
        },
        {
            key: 'expiry_date',
            label: 'Expiry Date',
            placeholder: 'YYYY-MM-DD',
        },
        {
            key: 'corporate_invoice_id',
            label: 'Invoice Number',
            placeholder: 'Invoice Number',
        },
    ],
};

// Default search configuration
export const DEFAULT_SEARCH_CONFIG = {
    searchKey: '',
    searchId: 'id',
    statusKey: 'ALL',
    isClearable: false,
    label: 'Voucher ID',
    searchPlaceholder: 'Voucher ID',
};
